import Vue from 'vue'
import axios from 'axios'

const axiosCustom = axios.create({
    baseURL: process.env.VUE_APP_API_URL,
    headers: {
        "company": 0
    }
});

axiosCustom.interceptors.request.use(config => {
    NProgress.start()
    // Atualiza o token em cada requisição
    config.headers['token'] = localStorage.getItem("token")
    return config
})

axiosCustom.interceptors.response.use(response => {
    NProgress.done()
    return response
})
Vue.use({
    install(Vue) {
        Vue.prototype.$clubApi = axiosCustom
    }
})

export default axiosCustom